export const tooltipDefaultDelay = 500;
